var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import AudioElm from './audio';
import { CurrentConnectionEvents, } from '../../../helpers/livekit/types';
const AudioElements = ({ currentConnection }) => {
    _react_refresh_temp_2();
    const [audioSubscribers, setAudioSubscribers] = useState();
    useEffect(() => {
        if (currentConnection.audioSubscribersMap.size) {
            setAudioSubscribers(currentConnection.audioSubscribersMap);
        }
        currentConnection.on(CurrentConnectionEvents.AudioSubscribers, setAudioSubscribers);
        return () => {
            currentConnection.off(CurrentConnectionEvents.AudioSubscribers, setAudioSubscribers);
        };
    }, [currentConnection]);
    const renderElms = useMemo(() => {
        if (!audioSubscribers) {
            return null;
        }
        const elms = [];
        audioSubscribers.forEach((participant) => {
            participant.tracks.forEach((track) => {
                elms.push(_jsx(AudioElm, { userId: participant.identity, track: track }, track.trackSid));
            });
        });
        return elms;
    }, [audioSubscribers]);
    return _jsx(_Fragment, { children: renderElms });
};
_react_refresh_temp_1 = AudioElements;
$RefreshReg$(_react_refresh_temp_1, "AudioElements");
_react_refresh_temp_2(AudioElements, "QM5ws4UKqUS/E1DU4LRXidNHPIQ=");
export default AudioElements;
